import { Container, Col, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import proImg6 from '../assets/img/profile.jpg';

export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 4
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 3
        }
    };
    return (
        <section className="skill">
            <Container>
                <Row className="align-items-center">
                    <Col xl={7} md={6}>
                        <h1>About Me</h1>
                        <p>
                        My experience ranges from product management in agile environments to interface design and the implementation of technological solutions. 
                        I have worked as a Product Owner and Designer, leading multidisciplinary teams and creating user-centered products.
                        </p>
                    </Col>
                    <Col className="profileImg" xl={5} md={6}>
                        <img src={proImg6} alt="profileImg" />
                    </Col>
                    <Col>
                        <h2>Stack</h2>
                        <div className="skill-bx" id="skills">
                            <Carousel className="skills-slider" responsive={responsive} infinite={true}>
                            <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg" alt="skill img8" />
                                    <h4>git</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="skill img9" />
                                    <h4>React</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg" alt="skill img10" />
                                    <h4>LARAVEL</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/astro/astro-original.svg" alt="skill img11" />
                                    <h4>ASTRO</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg" alt="skill img12" />
                                    <h4>TAILWIND</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-plain.svg" alt="skill img7" />
                                    <h4>PostgreSQL</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" alt="skill img3" />
                                    <h4>Bootstrap</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg" alt="skill img4" />
                                    <h4>JavaScript</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg" alt="skill img5" />
                                    <h4>PHP</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg" alt="skill img6" />
                                    <h4>MySQL</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain.svg" alt="skill img1" />
                                    <h4>HTML5</h4>
                                </div>
                                <div className="item">
                                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg" alt="skill img2" />
                                    <h4>CSS3</h4>
                                </div>
                            </Carousel>
                        </div>
                    </Col>
                </Row>

            </Container>
        </section>
    );
}